import { render, staticRenderFns } from "./SentimentAnalysis.vue?vue&type=template&id=717116f9&"
import script from "./SentimentAnalysis.vue?vue&type=script&lang=js&"
export * from "./SentimentAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports